export default function isPlainObject(
  value: unknown,
): value is Record<string, unknown> {
  const isObject = typeof value === "object";
  const isNotNull = value !== null;
  const isNotArray = !Array.isArray(value);
  const isObjectConstructor = value?.constructor === Object;

  return isObject && isNotNull && isNotArray && isObjectConstructor;
}
